import axios from "axios";
import { logout } from "../lib/auth";
import { outsideEntryFormTableColumn } from "../config/outsideEntryForm";

import { dataDifine, EditDataDifine } from "../config/dataInterface";
import { CONST } from "../config/const";
import { makeParams } from "./common";

// 外部ETフォーム一覧取得
export async function getOutsideEntryForms(props: {
  [key: string]: number | string;
}) {
  try {
    const path = "outsideEntryForms";
    const params = makeParams(outsideEntryFormTableColumn.dataColumn, props);
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    if (response.data.fetch_data === "null") {
      return null;
    }
    const outsideEntryForms: dataDifine[] = response.data.fetch_data;
    const countOutsideEntryForms: string = response.data.count_data;
    return { outsideEntryForms, countOutsideEntryForms };
  } catch (error) {
    // logout();
  }
}

// 外部ETフォーム詳細
export async function getOutsideEntryForm(id: string) {
  try {
    const path = "outsideEntryForm";
    const params = { id };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.detail_data[0];
  } catch (error) {
    // logout();
    return { option_data: [] };
  }
}

// 外部ETフォーム編集
export async function putOutsideEntryForm(editData: EditDataDifine) {
  try {
    const path = "outsideEntryForm";
    const params = { id: editData.tableId };
    const bodys = {
      id: editData.tableId,
      key: editData.key,
      value: editData.value,
      editValue: editData.editValue,
    };
    const response = await axios.put(CONST.apiUrl2 + path, {
      params,
      bodys,
    });
    return response.data.edit;
  } catch (error) {
    // logout();
  }
}

// 外部ETフォーム登録
export async function postOutsideEntryForm(addData: {
  [key: string]: string | boolean | any[];
}) {
  try {
    const path = "outsideEntryForm";
    const bodys = { addData };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}

// 外部ETフォーム削除
export async function deleteOutsideEntryForm(id: string) {
  try {
    const path = "outsideEntryForm";
    const params = { id };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// 外部ETフォーム一括質問登録
export async function postOutsideEntryFormOptions(
  editIDs: number[],
  select_option: {
    option_name: string;
    sns_send: 0 | 1;
    required_optional: 0 | 1;
    option_type: 0 | 1 | 2 | 3 | 4;
    option_default_value: string;
    change_value_conf: 0 | 1;
    option_comment: string;
    tel_flg: 0 | 1;
    name_flg: 0 | 1;
    zip_code_flg: 0 | 1;
    address_flg: 0 | 1;
    space_flg: 0 | 1;
    mail_address_flg: 0 | 1;
    form_tel_flg: 0 | 1;
    multi_text_flg: 0 | 1;
    half_width_number_flg: 0 | 1;
    option_select: string[];
  }
) {
  try {
    const path = "outsideEntryForms/edit/optionNames";
    const bodys = { editIDs, select_option };
    const response = await axios.post(CONST.apiUrl2 + path, {
      bodys,
    });
    return response.data.add;
  } catch (error) {
    // logout();
  }
}
// 外部ETフォーム一括質問削除
export async function deleteOutsideEntryFormOptions(
  editIDs: number[],
  delete_option_names: string[]
) {
  try {
    const path = "outsideEntryForms/edit/optionNames";
    const params = { editIDs, delete_option_names };
    const response = await axios.delete(CONST.apiUrl2 + path, {
      params,
    });
    return response.data.delete;
  } catch (error) {
    // logout();
  }
}

// 外部ETフォーム一括質問削除前の質問名一覧取得
export async function getOutsideEntryFormDeleteOptionNames(editIDs: number[]) {
  try {
    const path = "outsideEntryForms/edit/optionNames";
    const params = { editIDs };
    const response = await axios.get(CONST.apiUrl2 + path, {
      params,
    });
    const optionName: { option_name: string }[] = response.data.option_name;
    return optionName;
  } catch (error) {
    // logout();
    return [];
  }
}
